import Model from "./base/model";

class CompanyLogo extends Model {
  resourceName() {
    return "company_logo";
  }

  fields() {
    return {
      avatar_path: "",
    };
  }

}

export default new CompanyLogo();
